var exports = {
  "m": "Wrapper__hMhu4M",
  "H": "Canvas__4oLaoi",
};

module.exports = exports;
